<!-- ----------------------------------------------- -->
<template>
  <div class="legend-content">
    <v-container>
      <v-row>
        <v-col :cols="4" class="pa-0 pb-3 location-img">
          <img :src="imgResource.currentLocation" style="height: 38px;" />
        </v-col>
        <v-col :cols="8" class="pa-3 pr-1">
          <span class="location-text">
            {{ textResource.currentLocation }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="4" class="pa-0 pb-3 location-img">
          <img :src="imgResource.registrationPoint" style="height: 38px;" />
        </v-col>
        <v-col :cols="8" class="pa-3 pr-1">
          <span class="location-text">
            {{ textResource.registrationPoint }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="4" class="pa-0 pb-3 location-img">
          <img :src="imgResource.obsBlank" style="height: 38px;" />
          <div class="badge">
            <img :src="imgResource.badge" style="height: 15px;" />
          </div>
        </v-col>
        <v-col :cols="8" class="pa-3 pr-1">
          <span class="location-text">
            {{ textResource.obsBlank }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="4" class="pa-0 pb-3 location-img">
          <img
            :src="imgResource.breakWater"
            style="height: 38px;"
            class="mt-3"
          />
        </v-col>
        <v-col :cols="8" class="pa-3 pt-0 pr-1">
          <span class="location-text">
            {{ textResource.breakWater }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 現在位置・登録地点
 * LegendLocation.vue
 * @author LIS
 */
export default {
  name: "legend-location",
  data() {
    return {
      imgResource: {
        currentLocation: "/kawabou/img/p_point.png",
        registrationPoint: "/kawabou/img/map_icons/registration_point1.svg",
        obsBlank: "/kawabou/img/obs_blank.svg",
        badge: "/kawabou/img/map_icons/badge.png",
        breakWater: "/kawabou/img/map_icons/breakwater_line.svg",
      },
      textResource: {
        currentLocation: "現在位置",
        registrationPoint: "登録地点",
        obsBlank: "登録観測所",
        breakWater: "堤防が決壊すると登録地点が3時間以内に浸水する箇所",
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.legend-content {
  width: 210px;
  .location-img {
    display: flex;
    justify-content: flex-end;
    position: relative;
    .badge {
      position: absolute;
      top: -3px;
      right: 0px;
    }
  }
  .location-text {
    font-size: 0.9rem;
    color: black;
  }
}
</style>
